module.exports = __webpack_public_path__ + "static/media/arrow.aad2ce00.svg";